module.exports = __webpack_public_path__ + "img/legal_hov_pre_img.e71be878.png";